import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class WorkflowRandomisationRestService {
	
	private endpoint = `${environment.serverEndpoint}/api/projects`;
	
	constructor(private httpClient: HttpClient) { }
	
	isItemRandomizable(projectID: string, itemID: string): Observable<boolean> {
		const url = `${this.endpoint}/${projectID}/item/${itemID}/randomizationstatus`;
		return this.httpClient.get<{isRandomizationPossible: boolean}>(url).pipe(map(dto => !!dto.isRandomizationPossible));
	}
	
	doItemRandomization(projectID: string, participantID:string, itemID: string): Observable<string> {
		const url = `${this.endpoint}/${projectID}/participants/${participantID}/item/${itemID}/randomize`;
		return this.httpClient.post(url, null, { responseType: 'text' });
	}
	
	resetItemRandomization(projectID: string, participantID:string, itemID: string): Observable<void> {
		const url = `${this.endpoint}/${projectID}/participants/${participantID}/item/${itemID}/randomize`;
		return this.httpClient.delete<void>(url);
	}
}
